import { authActions } from '@crm/core';
import { AccountSettingsLayout } from '@shared-components/modules';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route } from 'react-router-dom';
import ChangePasswordSettings from './change-password';

const UserAccountSettings: React.FC = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(authActions.getAuthUser());
  }, []);
  return (
    <div className="content_margin--fluid">
      <AccountSettingsLayout>
        <Route
          exact
          path="/dashboard/account-settings"
          component={ChangePasswordSettings}
        />
      </AccountSettingsLayout>
    </div>
  );
};

export default UserAccountSettings;
